import {
  Swiper, Scrollbar, Keyboard,
} from 'swiper';

const swiperContainerClass = '.carousel__swiper';

function initcarousel(container) {
  // eslint-disable-next-line no-new
  new Swiper(container, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    grabCursor: true,
    breakpoints: {
      768: {
        spaceBetween: 15,
      },
    },
    freeMode: true,
    modules: [Scrollbar, Keyboard],
    keyboard: {
      enabled: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
      dragClass: 'carousel__scrollbar-drag',
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/carousel', ($block) => {
      initcarousel($block.find(swiperContainerClass)[0]);
    });
  } else {
    initcarousel(swiperContainerClass);
  }
});
